import i18next from 'i18next';

export const getProcessList = () => {
  const processList = i18next.t('architectPage.processList', {
    returnObjects: true,
  }) as { number: number; label: string; description: string; img?: any }[];

  return processList;
};
